import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'

import general from '@/store/modules/general'

//funciones auxiliares
import { util } from '@/util.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    G: general,
  },
  state: {
    // store componentes reutilizables
    token: 'castS_token',

    aplica: {
      titulo: "Castellón Senior",
      subtitulo: "Programa de Vacaciones Sociales para Mayores",
      subtitulo2: "Diputación de Castellón",
      programa: "20YY-20YY",
      activo: 1,
      admon: 0,
      year: new Date().getFullYear(),
      empresa: {
        nombre: "Viajes Cemo",
        telefono: "950 62 70 19",
        email: "castellonsenior@viajescemo.com",
        direccion: "Avda. las Gaviotas, 12-14",
        poblacion: "04740 Roquetas de Mar (Almeria)"
      }
    },

    auth: {
      logueado: false,
      error: '',
      user: {},
      token: '',
      //token: localStorage.getItem(this.token) || "",
    },

    agencias: [],
    hoteles: {
      destinos: {},
      salidas: {},
      hoteles: {},
      hotel: {},
      turno: {},
      turnos: {
        items: [],
        fields0: [
          {key:'hotel',label:'Establecimiento'},
          {key:'xfhe',label:'Entrada'},
          {key:'noc',label:'Noches'},
          {key:'pre',label:'Precio'},
          {key:'action', label:''}
        ],
        fields: [
            //{key:'sal',label:'Transporte'},
            {key:'xfhe',label:'Entrada'},
            // {key:'fhs',label:'Salida'},
            {key:'noc',label:'Noches'},
            {key:'pre',label:'Precio'},
            //{key:'lib',label:'*Libres'},
            {key:'action', label:''}
        ],
      },
    },
    exped: {
      items: [],
      fields: [
          {key:'id',label:'Exp'},
          {key:'d1',label:'DNI'},
          {key:'n1',label:'Ape-Nombre'},
          {key:'pob',label:'Poblacion'},
          {key:'tfn1',label:'Teléfono'},
          //{key:'action', label:''}
      ],
      //busqueda expedientes pulsado
      busca: 1,
    },


    // datos de la reserva (reservar)
    reserva: {
      id: 0,age: 0,exp:'',exp2:'',exp3:'',
      d1: '',n1:'',d2:'',n2:'',d3:'',n3:'',d4:'',n4:'',
      pob:'',pro:'',tf1:'',tf2:'',ema: '',
      hot:0,fhe:'',fhs:'',noc:0,reg:'PC',
      pax:0,tpp:'00',tph:'3',ind:0,
      tra:1,seg:0,obs:'',
      pre:0,sup:0,com:0,tot:0,pag:0,
      chk: false,
    },
    // Reserva Info Consulta
    iReserva: {
      id:0
    },

    ////////////////////// errores preconfig
    errores: {
      user:   'Usuario No existe',
      passwd: 'Password incorrecto',
      sesion_caducada: 'La sesion iniciada ha caducado, deberá acceder de nuevo.',
      email:  'Email No Correcto',

    },

    ////////////////////// componentes
    modalVisible: false,
    modalComponent: null,

    comps: {

    }

  },
  getters: {
    authToken: state => state.auth.token,

    hotel_imagen: state=> (hot) => {
      let url=state.G.url_img + '?w=123|vc_agencias|hoteles_img|' + hot;
      return url;
    },

  },
  mutations: {
    //funciones comunes
    loading(state,ok=true,txt='') {
      state.comps.loading.show(ok,txt);
    },
    //alerta
    alerta(state,o=false,t=null) {
      if (!o) {
        o={mensaje:'Mensaje ...',btn:['ok']}
      }
      state.comps.alerta.open(o,t);
    },

    // de momento la buena
    // ventana modal (aceptar) en app
    modal(state,{tit,msg,time}) {
      console.log('modal',tit, msg, time);
      state.comps.modal.show(tit, msg, time);
    },

    /////////////// modal
    showModal(state, componentName) {
      state.modalComponent = componentName;
      state.modalVisible = true;
    },
    hideModal(state) {
      state.modalVisible = false;
    },

    ////////////////////////// login desde actions
    async login_back(state, r) {
      console.log('** STORE.LOGIN_BACK',r,state);

      //guardamos datos
      if (r.sql.error) {
        await this.commit('login_off',r.sql.msg);
        return;

      } else {
        state.auth.logueado=true;
        //state.auth.token=r.datos.token;
        state.auth.user=r.r[0].user;
        state.auth.error='';
        //
        state.aplica.programa=r.r[0].aplica.programa;
        state.aplica.activo=Number(r.r[0].aplica.activo);
        state.aplica.admon=Number(r.r[0].aplica.admon);

        // datos iniciales complementarios
        // agencias,hoteles
        await this.dispatch('datos_iniciales',r.r[1]);


      }

      state.auth.token=r.r[0].token;
      sessionStorage.setItem(state.token,r.r[0].token);

      //console.log('** STORE.LOGIN_BACK2',r,state);
    },

    async login_off(state, err='') {
      state.auth.token='';
      state.auth.logueado=false;
      state.auth.error=err;
      state.auth.user={};
      //llamar para quitar sesion ??????
      //sessionStorage.clear;
      sessionStorage.removeItem(state.token);
      console.log("* store.login_off",state.auth.token,sessionStorage);
    },

    ///////////////////////////////////////////////////////////
    hoteles_back(state, r) {
      state.hoteles.hoteles=r[0];
      state.hoteles.tipoEstancia=r[1];
      //state.hoteles.hotel={};
      //state.hoteles.turno={};
      //state.hoteles.turnos.items=[{}];
    },

  },
  actions: {

    async isLogin(context) {
      context.state.auth.token=sessionStorage.getItem(context.state.token) || "";
      let token = context.getters["authToken"];

      console.log("* store.isLogin",token);

      if (!token) {
        context.commit('login_off');
        return;
      }

      let arg={ token: context.state.auth.token };
      await context.dispatch('login',arg);
    },

    async login(context, arg) {
      context.commit('loading');
      //let args={ atoken: context.state.auth.token };
      let r=await context.dispatch('exec',{api:'login', arg });
      await context.commit('login_back', r);

      context.commit('loading', false);
    },

    // llamamos desde login_back
    async datos_iniciales(context, r) {
      console.log("* store.datos_iniciales -- no llamada - sin datos", context.state.auth.user, r);
      // no llamada pero lo recojemos desde login r[1]
      // agencias,...
      context.state.agencias=r[0];

      // hoteles leidos en el login
      this.commit('hoteles_back', r[1]);

    },

    async hoteles(context) {
      let arg={ token: context.getters["authToken"], img:1 };
      let r=await context.dispatch('exec',{api:'hoteles', arg });
      console.log('************** store.hoteles', r);

      let data=r.r;
      if (await context.dispatch('error',{r, tit:'HOTELES'})) data=[[],[]];

      await context.commit('hoteles_back', data);
    },

    async hotel_precios(context, hotel) {
        console.log("store.hotel_precios******************",hotel, context.getters["authToken"]);

        //asignamos hotel (solo en seleccion)
        context.state.hoteles.hotel=hotel;
        context.state.hoteles.turnos.items=[]; // inicializamos turnos

        context.commit('loading');
        let arg={ hot: hotel.hot || '*', token: context.getters["authToken"] };
        let r=await context.dispatch('exec',{api:'hoteles_turnos', arg});
        context.commit('loading', false);

        let data=r.r;
        if (await context.dispatch('error',{r,tit:'HOTEL_PRECIOS'})) data=[[]];

        context.state.hoteles.turnos.items = util.object_array(data[0]);
    },

    async hotel_imagen2(context, hot) {
      let arg={ token: context.getters["authToken"], id: hot };
      let r=await context.dispatch('exec',{api:'hotel_img', arg});
      let url=context.state.G.urlTMP + r.r[0];
      console.log('*hotel_imagen2_url',url);
      return url;
    },

    ///////////////////////////////////////////////////////////////
    //exec
    async exec(context, {api, arg}) {
      let A=context.state.G.abk_url;
      A.token=context.state.auth.token;
      //A.api=api;
      A.accion=api;
      A.args=arg;

      let r = await context.dispatch("ajaxRequest", A);

      return r;
    },

    //ajax
    async ajaxRequest(context, args) {
      console.log("------------AJAXREQUEST ", args);
      try {
        return Axios.post(context.state.G.url, args, {
          headers: {
              "Content-Type": "application/json"
          }
        }).then(result => {
          console.log("------------------------------------AJAXREQUEST RECIBIDO: ", result.data);
          if (!result.data.error==='undefined') {
            alert(result.data);
            return false;
          }
          return result.data;
        })
      } catch (error) {
        // error en la recuperación de datos
        console.log("------------AJAXREQUEST ERROR !!!!!!", error);
        return false;
      }
    },

    // errores
    async error(context, {r, tit='E R R O R'}) {
      let OK,KO=false;

      if (r.sql.error) {
        let m=r.sql.msg;
        if (m=='error:101') { m='Sistema CERRADO<br>Estamos elaborando los Programas de Vacaciones para la próxima temporada.<br><br><u>Por favor, vuelve a visitarnos un poco más adelante'; KO=true; }
        if (m=='error:102') { m='Sistema en Administración. Disculpe las molestias'; KO=true; }
        if (m=='error:201') { m='Has estado demasiado tiempo inactivo.<br>Por seguridad la sesion iniciada se cerrará.<br>Debe acceder de nuevo'; KO=true; }
        if (m=='error:202') { m='Tu sesión ha caducado. Se recargará la página para que puedas volver a identificarte'; KO=true; }
        if (m=='error:203') { m='La sesion iniciada se cerrará.<br>Ha superado el tiempo de Inactividad de su sesión.<br>Debe acceder de nuevo'; KO=true; }
        if (m=='error:204') { m='Ha superado el número de Intentos fallidos, debera esperar al menos 5 minutos.'; KO=true; }

        context.commit('modal',{tit, msg: m, time:0});

        if (KO) {
          await context.commit('login_off');
          if (this.$route.name!='/') this.$router.push('/');
        }
        OK=true;
      }
      //console.log('**store.error',r,OK,KO);

      return OK;
    },
  }
})
